import { useAtomValue } from 'jotai'
import React from 'react'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { useCreateSurveyGroupFilterRestoringParams } from '~/hooks/useCreateSurveyGroupFilterRestoringParams'

import {
  commentAtom,
  dataDisplayTypeAtom,
  hiddenBrandIdsAtom,
  hiddenLabelBrandIdsAtom,
  hiddenSurveyIdsAtom,
  isChartMaxUnifiedAtom,
  tableChartTypeAtom,
} from '../../atoms'
import { pathKey } from '../../utils'
import { useBrandAccountId } from '../useBrandAccountId'

import { type RestoringParams } from './types'

export const useRestoringParams = (hash: RestoringParams['hash']) => {
  const createSurveyGroupFilterRestoringParams =
    useCreateSurveyGroupFilterRestoringParams()

  const brandAccountId = useBrandAccountId()

  const commentRecord = useAtomValue(commentAtom)

  const tableChartType = useAtomValue(tableChartTypeAtom)
  const dataDisplayType = useAtomValue(dataDisplayTypeAtom)
  const isChartMaxUnified = useAtomValue(isChartMaxUnifiedAtom)

  const hiddenBrandIds = useAtomValue(hiddenBrandIdsAtom)
  const hiddenLabelBrandIds = useAtomValue(hiddenLabelBrandIdsAtom)
  const hiddenSurveyIds = useAtomValue(hiddenSurveyIdsAtom)

  return React.useMemo(
    () =>
      createSurveyGroupFilterRestoringParams<RestoringParams>(
        compile(pathKey, { brandAccountId }),
        {
          version: 2,
          revision: 2,
          tableChartType,
          dataDisplayType,
          isChartMaxUnified,
          hiddenBrandIds,
          hiddenLabelBrandIds,
          hiddenSurveyIds,
          comment: commentRecord[hash] ?? '',
          hash,
        },
      ),
    [
      brandAccountId,
      commentRecord,
      createSurveyGroupFilterRestoringParams,
      dataDisplayType,
      hash,
      hiddenBrandIds,
      hiddenLabelBrandIds,
      hiddenSurveyIds,
      isChartMaxUnified,
      tableChartType,
    ],
  )
}
